module.exports = __webpack_public_path__ + "ded60aa36e641d919b9fabfdf1ade027.svg";